
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseMixin } from "@/mixins/baseMixin";
import axios from "axios";
import FileSaver from "file-saver";
import Loading from "@/components/Loading.vue";

@Component({
  components: { Loading },
  mixins: [BaseMixin]
})
export default class DownloadOrderFormPageButton extends Vue {
  public name: string = "DownloadOrderFormPageButton";
  @Prop()
  public pageId!: number;

  protected step = 1;

  protected modalId = "download-order-form-page-modal";

  protected withSku = true;

  protected cbPrintSelf = false;

  protected cbPrintByPrinter = false;

  protected cbWithSkus = true;

  protected printByPrinterSheetCountLabel = "";

  protected prices = [];

  protected showModal() {
    this.$bvModal.show(this.modalId);
  }

  protected onCloseModal(modalId: string): void {
    this.reset();
    this.$bvModal.hide(modalId);
  }

  protected reset(): void {
    this.step = 1;
    this.cbPrintSelf = false;
    this.cbPrintByPrinter = false;
    this.cbWithSkus = true;
    this.printByPrinterSheetCountLabel = "";
  }

  protected onSend(): void {
    this.step = 2;
    this.$crudService
      .update({
        resource: "order-form-download",
        id: this.pageId,
        descriptionField: "",
        data: {
          is_self_print: this.cbPrintSelf,
          is_print_by_printer: this.cbPrintByPrinter,
          is_with_skus: this.cbWithSkus,
          print_by_printer_sheet_count_label: this.printByPrinterSheetCountLabel
        }
      })
      .then((response: any) => {
        console.debug("DownloadOrderForm Response 1", response.data);
        this.step = 3;
        if (this.cbPrintSelf && response?.data?.download_url) {
          this.downloadFile(response.data.download_url);
        }
      });
    console.debug(
      "on send click (DownloadOrderFormPageButton",
      this.cbPrintByPrinter,
      this.cbPrintSelf
    );
  }

  protected async downloadFile(url: string) {
    const fileResponse = await axios.get(url, {
      responseType: "blob"
    });

    FileSaver.saveAs(fileResponse.data, "Expovina_Bestellformular.pdf");
  }

  protected fetchPricesDropdownData(): void {
    this.$crudService
      .findAll({
        resource: "order-form/prices-data",
        descriptionField: ""
      })
      .then((response: any) => {
        console.debug("Foo", response.data);
        if (response.data) {
          this.prices = response.data;
          console.debug("foo2", this.prices);
        }
      });
  }

  created() {
    this.fetchPricesDropdownData();
  }
}
